import { Component, Input, OnInit } from '@angular/core';
import { KPI } from '../../../@core/api';
import { DatePipe, LowerCasePipe } from '@angular/common';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { LightgalleryModule } from 'lightgallery/angular';
import { LightGallery } from 'lightgallery/lightgallery';
import lgZoom from 'lightgallery/plugins/zoom';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NbCardModule, NbListModule, NbTooltipModule } from '@nebular/theme';
import { LightGalleryCoreSettings } from 'lightgallery/lg-settings';
import { RequireAtLeastOne } from '../../../@core/api/models';
import { LIGHT_GALLERY_LICENSE_KEY } from '../../../../license-keys';

export interface MappedDefault extends KPI.Default {
  userName: string;
  date: string;
  gallerySettings: any;
  lightGallery: LightGallery;
  onInit?: Function;
  openGallery?: Function;
}

@Component({
  selector: 'app-defaults-list',
  templateUrl: './defaults-list.component.html',
  styleUrls: ['./defaults-list.component.scss'],
  standalone: true,
  imports: [
    NbCardModule,
    NbListModule,
    FontAwesomeModule,
    NbTooltipModule,
    LowerCasePipe,
    TranslateModule,
    LightgalleryModule,
  ]
})
export class DefaultsListComponent implements OnInit {

  @Input() defaults: KPI.Default[];
  public mappedDefaults: MappedDefault[] = [];

  /**
   * Image gallery settings
   */
  public settings: RequireAtLeastOne<LightGalleryCoreSettings> = {
    counter: false,
    speed: 500,
    plugins: [lgZoom, lgThumbnail],
    dynamic: true,
    dynamicEl: [],
    licenseKey: LIGHT_GALLERY_LICENSE_KEY,
    zoomFromOrigin: true,
  };

  public lightGalleries: { [defaultId: number]: LightGallery } = {};

  constructor(
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.mappedDefaults = this.defaults.map((d, i) => {
      const user = d.user;
      let userName = '';
      if (user.first_name && user.last_name) {
        userName += `${user.first_name[0]}. ${user.last_name}`;
        if (user.corporate_name) {
          userName += ` (${user.corporate_name})`;
        }
      } else if (user.email) {
        userName = user.email;
      } else {
        userName = this.translate.instant(
          'pages.common.charts.lifecycle-chart.unknown-user',
        );
      }
      const pipe = new DatePipe(this.translate.getBrowserCultureLang());
      const date = pipe.transform(d.datetime, 'd MMM y');

      return {
        ...d,
        userName,
        date,
        gallerySettings: {
          ...this.settings,
          dynamicEl: d.notation_pictures.map(p => ({
            id: p.id,
            src: p.picture,
            thumb: p.thumbnail,
          })),
        },
        lightGallery: null,
        onInit: (detail): void => {
          this.lightGalleries[i] = detail.instance;
        },
        openGallery: () => {
          this.lightGalleries[i].openGallery();
        },
      };
    });
  }

}
